const isPublicForm = (route) => !!route?.meta?.publicTdotParticipation || /^\/tdot\/mitmachen\/?$/i.test(route?.path || "")
const isCalendarLink = (route) => /^\/guestbook-entry\/?$/i.test(route?.path || "") && route?.query?.mode === "tdot"

export function isTdotParticipationLink(route) {
  return isPublicForm(route) || isCalendarLink(route)
}

export function isPublicTdotEntry(route, hasStaffSession = false) {
  return isPublicForm(route) || (isCalendarLink(route) && !hasStaffSession)
}

export function publicTdotLocation(route) {
  const studio = typeof route?.query?.studio === "string" ? route.query.studio.trim().toLowerCase() : ""
  return { name: "tdotParticipation", query: studio ? { studio } : {}, replace: true }
}
